import { loadAnalyticsDeferred, runWhenIdle } from './src/utils/performance-helpers';

// Client-side performance optimizations
export const onClientEntry = () => {
  // Defer analytics loading to prevent main thread blocking
  loadAnalyticsDeferred();
  
  runWhenIdle(() => {
    // Preconnect to external domains
    const preconnectDomains = [
      'https://fonts.googleapis.com',
      'https://fonts.gstatic.com',
      'https://vercel.live',
      'https://www.googletagmanager.com'
    ];
    
    preconnectDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  });
};

// Optimize route updates
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Defer non-critical operations after route change
  runWhenIdle(() => {
    // Lazy load images in viewport
    if ('IntersectionObserver' in window) {
      const images = document.querySelectorAll('img[data-src]');
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        });
      });
      
      images.forEach(img => imageObserver.observe(img));
    }
  });
};

// Code splitting for routes
export const onPrefetchPathname = ({ pathname }) => {
  // Prefetch route data during idle time
  runWhenIdle(() => {
    // Gatsby handles this internally, but we ensure it's done during idle time
    console.log(`Prefetching ${pathname} during idle time`);
  });
};